import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

import { filtersConfig } from './utils';

const namespace = 'smsMessageTrace';

const SmsMessageTraceModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig,
  },

  effects: {
    ...makeListEffects({
      namespace,
      fetchRoute: 'smsMessageTrace',
      fetchParams: 'smsMessageTrace',
    }),
    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
    },
    *closeDrawerView({ payload }, { put }) {
      yield put({
        type: 'closeDrawerViewReducer',
        payload,
      });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),

    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openView: payload.state,
        item: null,
        view: true,
      };
    },
    closeDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openView: payload.state,
        item: null,
        view: false,
      };
    },
  },
};

export default SmsMessageTraceModel;
